import {
    Component,
    OnInit,
    computed,
    ChangeDetectionStrategy
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators
} from '@angular/forms';
import { NgIf } from '@angular/common';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { AuthService } from '../../authentication/service/auth.service';
import { LoginRequest } from '../../protos/generated/admin.pb';

@Component({
    selector: 'app-sign-in',
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        NgIf
    ],
    templateUrl: './sign-in.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './sign-in.component.scss'
})
export class SignInComponent implements OnInit {
    // isToggled
    isToggled = false;

    constructor(
        private fb: FormBuilder,
        public themeService: CustomizerSettingsService,
        private authService: AuthService
    ) {
        this.authForm = this.fb.group({
            username: ['', [Validators.required, Validators.maxLength(20)]],
            password: ['', [Validators.required, Validators.minLength(8)]],
            rememberMe: [false]
        });
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    ngOnInit(): void {
        const reason = sessionStorage.getItem('auth_logout_reason');
        if (reason) {
            this.authService.errorMessage.set(reason);
            sessionStorage.removeItem('auth_logout_reason');
        }
    }

    // Password Hide
    hide = true;

    isLoading = computed(() => this.authService.loginLoading());
    errorMessage = computed(() => this.authService.errorMessage());

    // Form
    authForm: FormGroup;
    onSubmit() {
        const credentials = new LoginRequest({
            username: this.authForm.value.username,
            password: this.authForm.value.password,
            rememberMe: this.authForm.value.rememberMe
        });
        this.authService.login(credentials);
    }

    goToNextInput(nextElementId: string): void {
        const nextElement = document.getElementById(nextElementId);
        if (nextElement) {
            (nextElement as HTMLInputElement).focus();
        }
    }
}
